var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_12194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7611 17.3926L19.125 22.0298V10.1206C19.125 9.49961 18.621 8.99561 18 8.99561C17.379 8.99561 16.875 9.49961 16.875 10.1206V22.0298L12.2389 17.3937C11.799 16.9538 11.0869 16.9538 10.6481 17.3937C10.2082 17.8336 10.2082 18.5457 10.6481 18.9844L17.0122 25.3485C17.2822 25.6185 17.6512 25.7018 18.0012 25.6399C18.3499 25.7018 18.7201 25.6174 18.9901 25.3485L25.3542 18.9844C25.7941 18.5445 25.7941 17.8325 25.3542 17.3937C24.9131 16.9538 24.201 16.9538 23.7611 17.3926ZM18 -0.00439453C8.05953 -0.00439453 0 8.05396 0 17.9956C0 27.9373 8.05953 35.9956 18 35.9956C27.9405 35.9956 36 27.9361 36 17.9956C36 8.05513 27.9416 -0.00439453 18 -0.00439453ZM18 33.7456C9.30147 33.7456 2.25 26.6941 2.25 17.9956C2.25 9.29708 9.30147 2.24561 18 2.24561C26.6985 2.24561 33.75 9.29708 33.75 17.9956C33.75 26.6941 26.6985 33.7456 18 33.7456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_12194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.1b3274b9944bca589598d69087e4ee69.svg";
export { ForwardRef as ReactComponent };